export const STATIC_MEDIA_PATH = 'static_media';

export const STATIC_IMAGE_PATHS = {
	LOGO_WHITE: `${STATIC_MEDIA_PATH}/logo_white.webp`,
	LOGO_DARK: `${STATIC_MEDIA_PATH}/logo_dark.webp`,
} as const;

export const STATIC_IMAGE_IDS = {
	LOGO_WHITE: '2d99d54f-667b-419c-a1b3-daa077ce9cb0',
	LOGO_DARK: 'e3d76286-6b70-4bf4-938d-8e1ac554b3a0',
} as const;
